import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeatureGrid from "./components/FeatureGrid";
import ContentBoard from "./components/ContentBoard";
import FlashTimeline from "./components/FlashTimeline";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import Trust from "./components/Trust";
import Faq from "./components/Faq";
import CtaBand from "./components/CtaBand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <FeatureGrid />
        <ContentBoard />
        <FlashTimeline />
        <Services />
        <HowItWorks />
        <Trust />
        <Faq />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}